import React from 'react'
import createReactClass from 'create-react-class'
import ModalWrapper from './modal-wrapper'
import ModalContent from './modal-content'
import './refresh-token-modal-panel.scss'

export default createReactClass({
  getInitialState () {
    return {
      password: '',
      validationError: '',
    }
  },
  handleChange (event) {
    let target = event.target
    this.setState({
      [target.name]: target.value,
    })
  },
  onContinue (event) {
    event.preventDefault()
    let {password} = this.state
    if (!password) {
      this.setState({
        validationError: 'Password should not be empty.',
      })
    } else {
      this.setState({
        validationError: '',
      })
      this.props.refreshToken(password)
    }
  },
  renderErrorMessage () {
    let {validationError} = this.state
    let {authError} = this.props
    if (validationError) {
      return <div className="error">{validationError}</div>
    } else if (authError) {
      return <div className="error">{authError}</div>
    }
    return false
  },
  render () {
    let {isLoading} = this.props
    return (
      <ModalWrapper>
        <ModalContent title='Please enter password' {...this.props}>
          <form className='refresh-token' onSubmit={this.onContinue}>
            {this.renderErrorMessage()}
            <div className="form-field flex-display">
              <label htmlFor='password-input' className="password-label">Password</label>
              <input
                id='password-input'
                placeholder="password"
                name="password"
                type="password"
                value={this.state.password}
                onChange={this.handleChange}
                disabled={isLoading}/>
            </div>
            <div className="form-field btn-container flex-display refresh">
              <button className='btn btn-block' type="submit" disabled={isLoading}>{isLoading ? <i className="fa fa-spinner fa-spin"></i> : ''}Continue</button>
            </div>
          </form>
        </ModalContent>
      </ModalWrapper>
    )
  },
})



// WEBPACK FOOTER //
// ./src/components/modal-panels/refresh-token-modal-panel.js